<div class="line-left line-left--1 h-100" [style.backgroundColor]="lineLeft.firstLineColor || '#06ded8'"></div>
<div class="line-left line-left--2 h-100" [style.backgroundColor]="lineLeft.secondLineColor || '#9657d6'"></div>